import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';

@Metamodel.model({
    name: ModelConstants.genericCDataLinkedService,
    display: []
})
export class GenericCDataLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
}
